import React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import axios from "axios";

const DetailPanen = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  const handleBack = () => {
    navigate("/petanip");
  };

  const handleLogout = async () => {
    try {
      const response = await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );

      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      alert("Gagal logout. Silakan coba lagi.");
    }
  };

  const detailData = {
    1: {
      nama: "Gusti Luthfi F",
      alamat: "Terminal Raja Basa",
      jenisSawit: "E. guineensis",
      luasLahan: "10 ha",
      jumlahPanen: "1000 Kg",
      tanggalPanen: "2024-05-24",
      tanggal: "13/05/2024",
      berat: "1000 kg",
    },
    2: {
      nama: "Petani 2",
      alamat: "Alamat 2",
      jenisSawit: "E. guineensis",
      luasLahan: "15 ha",
      jumlahPanen: "1500 Kg",
      tanggalPanen: "2024-05-23",
      tanggal: "23/05/2024",
      berat: "1000 kg",
    },
    3: {
      nama: "Petani 3",
      alamat: "Alamat 3",
      jenisSawit: "E. guineensis",
      luasLahan: "15 ha",
      jumlahPanen: "1500 Kg",
      tanggalPanen: "2024-05-23",
      tanggal: "23/05/2024",
      berat: "1000 kg",
    },
  };

  const data = detailData[id];

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    // Ambil informasi user
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });
  }, []);

  return (
    <div className="d-flex flex-column">
      {/* Header */}
      <div className="header">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span>{userInfo.full_name} |</span>
          <button
            className="btn btn-outline-success btn-sm"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex">
        {/* Sidebar */}
        <div className="sidebar p-3">
          <p>Portal Sistem Traceability</p>
          <h6>Telsa Super Apps</h6>
          <p>
            <img src="/static/schedule_11145854.png" alt="Date" />
            {tanggal}
          </p>
          <div className="list-group list-group-flush">
            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/petani" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/petani" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" /> Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/petanirt" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/petanirt" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/Tanam.png" alt="Planting" /> Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/petanirp" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/petanirp" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/panen.png" alt="Harvest" /> Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/petanifp" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/petanifp" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/FinalPanen.png" alt="Final Panen" /> Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none ${
                location.pathname === "/petanip" ? "active text-white" : ""
              }`}
              style={{
                color: location.pathname === "/petanip" ? "white" : "black",
                cursor: "pointer",
              }}
            >
              <img src="/static/sell_8087698.png" alt="Sales" /> Penjualan
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <h2>
            Rencana Tanam - {data.tanggal} - {data.berat}
          </h2>
          <div className="divider"></div>

          {/* Tombol Kembali */}
          <button className="btn btn-kembali" onClick={handleBack}>
            Kembali
          </button>

          {/* Detail Container */}
          <div className="detail-container">
            <div className="detail-row">
              <span>Nama</span>
              <span className="separator">:</span>
              <span>{data.nama}</span>
            </div>
            <div className="detail-row">
              <span>Alamat</span>
              <span className="separator">:</span>
              <span>{data.alamat}</span>
            </div>
            <div className="detail-row">
              <span>Jenis Sawit</span>
              <span className="separator">:</span>
              <span>{data.jenisSawit}</span>
            </div>
            <div className="detail-row">
              <span>Luas Lahan</span>
              <span className="separator">:</span>
              <span>{data.luasLahan}</span>
            </div>
            <div className="detail-row">
              <span>Jumlah Panen</span>
              <span className="separator">:</span>
              <span>{data.jumlahPanen}</span>
            </div>
            <div className="detail-row">
              <span>Tanggal Panen</span>
              <span className="separator">:</span>
              <span>{data.tanggalPanen}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPanen;
